import React from "react";

const Bookmark = ({
  bookmarked = false,
  loading = false,
  onClick,
  defaultImage,
  activeImage,
  loadingImage,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={loading}
      style={{
        border: "none",
        background: "transparent",
        cursor: "pointer",
      }}
    >
      <img
        src={
          loading
            ? loadingImage || defaultImage
            : bookmarked
            ? activeImage
            : defaultImage
        }
        alt="bookmark"
        style={{ width: "24px", height: "24px" }}
      />
    </button>
  );
};

export default Bookmark;
